import { CheckoutButtonController } from '../controllers/checkoutButtonController';
import templateUrl from './checkoutButton.html';

export const CheckoutButtonComponent = {
    templateUrl,
    controller: CheckoutButtonController
};
